// 引入api
import { fun_PostAction, fun_Download } from "@/api";
//引入下载方法
import { fun_DownloadFile } from "@/utils/validate.js";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      /*************************公告信息***************************/
      guid: null, // 主键
      explain:true, // 收起 展开 否决投标的情况说明 
      price:true, // 收起 展开 评分比较一览表或者经评审的价格 
      bidder:true, // 收起 展开 投标人列表 
      // 项目信息
      detail: {
        /********************* 招标概况 *********************/
        guid: null, // 主键
        method: null, // 处理方式
        txtCnt: null, // 内容长度
        title: null, // 标题
        bdBh: null, // 标段编号
        gclb: null, // 工程类别
        bdName: null, // 标段名称
        gcLeiXing: null, // 工程类型
        kbTime: null, // 开标时间
        faBuTime: null, // 发布时间
        zbrName: null, // 建设单位
        jingBanRenName: null, // 经办人
        jingBanRenPhone: null, // 办公电话
        zbrAddress: null, // 联系地址
        zbDlName: null, // 招标代理机构
        zbDlJinBanRenName: null, // 经办人
        zbDlJinBanRenPhone: null, // 办公电话
        zbDlAddress: null, // 联系地址
        hangYeBuMenName: null, // 行业主管部门
        hangYeLianXiRen: null, // 联系人
        hangYeLianXiRenPhone: null, // 办公电话
        hangYeLianXiRenAddress: null, // 联系地址
        zhuGuanBuMenName: null, // 公共资源交易综合监管机构
        zhuGuanBuMenLianXiRen: null, // 联系人
        zhuGuanBuMenLianXiRenPhone: null, // 办公电话
        zhuGuanBuMenLianXiRenAddress: null, // 联系地址
        zhaoBiaoGaiKuang: null, // 招标概况
        gongShiShiJian: null, // 公示时间
        yiYiYuTouSu: null, // 异议与投诉
        ziGeNengLiTiaoJian: null, // 投标文件中的资格审查资料（资格能力条件）
        beiZhu: null, // 备注
        qiTaQingKuangShuoMing: null // 其他情况说明
      },
      /********************* 否决投标的情况说明 *********************/
      // 列表loading状态
      fbTableColumns: [
        {
          label: "投标人名称及其得分",
          prop: "tbrName"
        },
        {
          label: "被否决的依据",
          prop: "fbYiJu"
        },
        {
          label: "投标存在的具体问题",
          prop: "cunZaiWenTi"
        }
      ],
      fbTableData: [],
      /********************* 评分比较一览表或者经评审的价格 *********************/
      // 列表loading状态
      pwTableColumns: [
        {
          label: "投标人名称",
          prop: "tbrName"
        },
        {
          label: "评委1",
          prop: "fenShuA"
        },
        {
          label: "评委2",
          prop: "fenShuB"
        },
        {
          label: "评委3",
          prop: "fenShuC"
        },
        {
          label: "平均得分",
          prop: "pingJunFen"
        }
      ],
      pwTableData: [],
      /********************* 投标人列表 *********************/
      // 列表loading状态
      tbrTableColumns: [
        {
          label: "组织机构代码",
          prop: "tbrBh"
        },
        {
          label: "单位名称",
          prop: "tbrName"
        },
        {
          label: "是否中标候选人",
          prop: "isCandIdate"
        },
        {
          label: "评标排名",
          prop: "paiXu"
        },
        {
          label: "项目负责人",
          prop: "xiangMuFuZeRen"
        },
        {
          label: "资格证书编号",
          prop: "ziGeZhengShuBianHao"
        },
        {
          label: "投标报价(元)",
          prop: "tbbj"
        },
        {
          label: "质量标准",
          prop: "zl"
        },
        {
          label: "工期",
          prop: "gq"
        },
        {
          label: "资质情况",
          prop: "zzqk"
        },
        {
          label: "企业人员资质及业绩公示文件",
          prop: "fileList",
        },
      ],
      tbrTableData: []
    };
  },
  mounted() {
    // 获取主键
    this.guid = this.$route.query.guid;
    // 获取公告详情
    this.fun_GetDetail();
    // 获取否决投标的情况说明一览数据
    this.fun_GetFbList();
    // 评分比较一览表或者经评审的价格一览数据
    this.fun_GetPwList();
    // 投标人列表一览数据
    this.fun_GetTbrList();
  },
  // 自定义事件
  methods: {
    /***********************************公告信息**************************************/
    /**
     * 获取公告信息
     */
    fun_GetDetail() {
      // 请求
      fun_PostAction("/hiConstruction/bidEvaluationResultsDetail", {
        guid: this.guid // 主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          this.detail = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取否决投标的情况说明一览数据
     * @author 滕威
     */
    fun_GetFbList() {
      // 执行获取列表接口
      fun_PostAction("/hiConstruction/publicityBidEvaluationResultsFbList", {
        pidGuid: this.guid // 父亲主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.fbTableData = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 评分比较一览表或者经评审的价格一览数据
     * @author 滕威
     */
    fun_GetPwList() {
      // 执行获取列表接口
      fun_PostAction("/hiConstruction/publicityBidEvaluationResultsPwList", {
        pidGuid: this.guid // 父亲主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.pwTableData = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 投标人列表一览数据
     * @author 滕威
     */
    fun_GetTbrList() {
      // 执行获取列表接口
      fun_PostAction("/hiConstruction/publicityBidEvaluationResultsTbrList", {
        pidGuid: this.guid // 父亲主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.tbrTableData = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 下载
     * @author 滕威
     */
     fun_DownloadFiles(filePath) {
      if (filePath) {
        const form = {
          filePath: filePath
        };
        // 下载文件
        fun_Download("/downloadLocal", form).then(res => {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;
          if (fileNames) {
            let regFileNames = fileNames.match(/=(.*)$/)[1];
            // 调用下载文件公共方法
            fun_DownloadFile(res, decodeURIComponent(regFileNames));
          } else {
            fun_DownloadFile(res, Math.random() + ".pdf");
          }
        });
      } else {
        this.$message.error("文件不存在！");
      }
    },
  }
};
